module.exports = {
          srcSet: __webpack_public_path__ + "public/f1ef372082aae83bbd3b543efeba747a-80.png"+" 80w",
          images:[ {path: __webpack_public_path__ + "public/f1ef372082aae83bbd3b543efeba747a-80.png",width: 80,height: 80}],
          src: __webpack_public_path__ + "public/f1ef372082aae83bbd3b543efeba747a-80.png",
          toString:function(){return __webpack_public_path__ + "public/f1ef372082aae83bbd3b543efeba747a-80.png"},
          
          width: 80,
          height: 80
        }